/* redux-query mutation request actions */

import { mutateAsync } from 'redux-query';

import * as ReduxQueries from '../queries';

export const createClientMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.createClientMutation(accessToken, data, optimistic));
};

export const updateClientMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateClientMutation(accessToken, data, optimistic));
};

export const updateClientContactMutateAsync = (clientId: number, data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateClientContactMutation(accessToken, clientId, data, optimistic));
};

export const createClientContactMutateAsync = (clientId: number, data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.createClientContactMutation(accessToken, clientId, data, optimistic));
};

export const newAssociationMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newAssociationMutation(accessToken, data, optimistic));
};

export const updateAssociationMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateAssociationMutation(accessToken, data, optimistic));
};

export const updateReserveStudyChartMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateReserveStudyChartMutation(accessToken, data, optimistic));
};

export const updateComponentReplacementCostsMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateComponentReplacementCostsMutation(accessToken, data, optimistic));
};
export const updateAssociationInventoryMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateAssociationInventoryMutation(accessToken, data, optimistic));
};

export const newAssociationInventoryMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newAssociationInventoryMutation(accessToken, data, optimistic));
};

export const deleteAssociationInventoryMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteAssociationInventoryMutation(accessToken, data, optimistic));
};

export const newAssociationInventoryResearchMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newAssociationInventoryResearchMutation(accessToken, data, optimistic));
};

export const deleteAssociationInventoryResearchMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteAssociationInventoryResearchMutation(accessToken, data, optimistic));
};

export const newAssociationInventorySubgroupMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newAssociationInventorySubgroupMutation(accessToken, data, optimistic));
};

export const updateAssociationInventorySubgroupMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateAssociationInventorySubgroupMutation(accessToken, data, optimistic));
};

export const deleteAssociationInventorySubgroupMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteAssociationInventorySubgroupMutation(accessToken, data, optimistic));
};

export const duplicateAssociationInventorySubgroupMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.duplicateAssociationInventorySubgroupMutation(accessToken, data, optimistic));
};

export const duplicateAssociationInventoryMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.duplicateAssociationInventoryMutation(accessToken, data, optimistic));
};

export const updateAssociationInventoryItemsMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateAssociationInventoryItemsMutation(accessToken, data, optimistic));
};

export const deleteAssociationInventoryItemsMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteAssociationInventoryItemsMutation(accessToken, data, optimistic));
};

export const newUserInventoryTemplateMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newUserInventoryTemplateMutation(accessToken, data, optimistic));
};

export const applyUserInventoryTemplateMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.applyUserInventoryTemplateMutation(accessToken, data, optimistic));
};

export const applyRegionalComponentListTemplateMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.applyRegionalComponentListTemplateMutation(accessToken, data, optimistic));
};

export const copyAssociationInventoryToRegionalComponentListMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.copyAssociationInventoryToRegionalComponentListMutation(accessToken, data, optimistic));
};

export const updateUserInventoryTemplateMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateUserInventoryTemplateMutation(accessToken, data, optimistic));
};

export const renameUserInventoryTemplateMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.renameUserInventoryTemplateMutation(accessToken, data, optimistic));
};

export const deleteUserInventoryTemplateMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteUserInventoryTemplateMutation(accessToken, data, optimistic));
};

export const deleteUserInventoryTemplateItemMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteUserInventoryTemplateItemMutation(accessToken, data, optimistic));
};

export const newRegionalComponentListMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newRegionalComponentListMutation(accessToken, data, optimistic));
};

export const updateRegionalComponentListMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateRegionalComponentListMutation(accessToken, data, optimistic));
};

export const renameRegionalComponentListMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.renameRegionalComponentListMutation(accessToken, data, optimistic));
};

export const duplicateRegionalComponentListMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.duplicateRegionalComponentListMutation(accessToken, data, optimistic));
};

export const deleteRegionalComponentListMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteRegionalComponentListMutation(accessToken, data, optimistic));
};

export const newRegionalComponentListSubgroupMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newRegionalComponentListSubgroupMutation(accessToken, data, optimistic));
};

export const updateRegionalComponentListSubgroupMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateRegionalComponentListSubgroupMutation(accessToken, data, optimistic));
};

export const deleteRegionalComponentListSubgroupMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteRegionalComponentListSubgroupMutation(accessToken, data, optimistic));
};

export const duplicateRegionalComponentListSubgroupMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.duplicateRegionalComponentListSubgroupMutation(accessToken, data, optimistic));
};

export const deleteRegionalComponentListItemMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteRegionalComponentListItemMutation(accessToken, data, optimistic));
};

export const newRegionalComponentListItemMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newRegionalComponentListItemMutation(accessToken, data, optimistic));
};

export const updateRegionalComponentListItemMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateRegionalComponentListItemMutation(accessToken, data, optimistic));
};

export const duplicateRegionalComponentListItemMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.duplicateRegionalComponentListItemMutation(accessToken, data, optimistic));
};

export const newRegionalComponentListResearchMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newRegionalComponentListResearchMutation(accessToken, data, optimistic));
};

export const deleteRegionalComponentListResearchMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteRegionalComponentListResearchMutation(accessToken, data, optimistic));
};

export const updateOrderMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateOrderMutation(accessToken, data, optimistic));
};

export const deleteOrderMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteOrderMutation(accessToken, data, optimistic));
};

export const deleteAssociationMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteAssociationMutation(accessToken, data, optimistic));
};

export const newOrderMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newOrderMutation(accessToken, data, optimistic));
};

export const createNext3YearPlanSeqOrderMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.createNext3YearPlanSeqOrderMutation(accessToken, data, optimistic));
};

export const updateOrdersSetAsPaidMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateOrdersSetAsPaidMutation(accessToken, data, optimistic));
};

export const updateWonJobsMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateWonJobsMutation(accessToken, data, optimistic));
};

export const downloadKMLMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.downloadKMLMutation(accessToken, data, optimistic));
};

export const newInventoryComponent = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newInventoryComponentMutation(accessToken, data, optimistic));
};

export const updateLookupObjMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateLookupObjMutation(accessToken, data, optimistic));
};

export const newLookupObjMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newLookupObjMutation(accessToken, data, optimistic));
};

export const deleteLookupObjMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteLookupObjMutation(accessToken, data, optimistic));
};

export const updateComponentMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateComponentMutation(accessToken, data, optimistic));
};

export const newInventoryComponentObjMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newInventoryComponentMutation(accessToken, data, optimistic));
};

export const updateReplacementCostMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateReplacementCostMutation(accessToken, data, optimistic));
};

export const deleteReplacementCostMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteReplacementCostMutation(accessToken, data, optimistic));
};

export const newReplacementCostMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newReplacementCostMutation(accessToken, data, optimistic));
};

export const newStandardEvaluationMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newStandardEvaluationMutation(accessToken, data, optimistic));
};

export const updateStandardEvaluationMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateStandardEvaluationMutation(accessToken, data, optimistic));
};

export const deleteStandardEvaluationMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteStandardEvaluationMutation(accessToken, data, optimistic));
};

export const updateOutstandingBidMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateOutstandingBidMutation(accessToken, data, optimistic));
};

export const updateReminderBidMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateReminderBidMutation(accessToken, data, optimistic));
};

export const updateReminderBidsReminderDateMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateReminderBidsReminderDateMutation(accessToken, data, optimistic));
};

export const updateReminderBidsSendReminderEmailMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateReminderBidsSendReminderEmailMutation(accessToken, data, optimistic));
};

export const updateReminderBids3YearPlanStatusMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateReminderBids3YearPlanStatusMutation(accessToken, data, optimistic));
};

export const setBidsSentMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.setBidsSentMutation(accessToken, data, optimistic));
};

export const newClientMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newClientMutation(accessToken, data, optimistic));
};

export const updateUserMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateUserMutation(accessToken, data, optimistic));
};

export const activateUserMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.activateUserMutation(accessToken, data, optimistic));
};

export const newUserMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newUserMutation(accessToken, data, optimistic));
};

export const newUserResumeMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newUserResumeMutation(accessToken, data, optimistic));
};

export const updateRegionMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateRegionMutation(accessToken, data, optimistic));
};

export const newClientInviteMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.newClientInviteMutation(accessToken, data, optimistic));
};

export const updateReportScenarioMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.updateReportScenarioMutation(accessToken, data, optimistic));
};

export const copyReportScenarioMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.copyReportScenarioMutation(accessToken, data, optimistic));
};

export const deleteReportScenarioMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.deleteReportScenarioMutation(accessToken, data, optimistic));
};

export const toggleClientInviteMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.toggleClientInviteMutation(accessToken, data, optimistic));
};

export const resendClientInviteMutateAsync = (data: any, accessToken: string, optimistic: boolean) => {
    return mutateAsync(ReduxQueries.Queries.resendClientInviteMutation(accessToken, data, optimistic));
};



// WEBPACK FOOTER //
// ./src/actions/mutate.tsx